/** Shared 360° hotspot marker chrome (Digital Patrol + Wankhede 360). */

/** Outer tap target for asset hotspot markers. */
export const PATROL_HOTSPOT_MARKER_SIZE_PX = 56;
/** Inner icon image size inside the marker. */
export const PATROL_HOTSPOT_ICON_SIZE_PX = 48;
/** API URL signal button diameter (green / red / yellow). */
export const PATROL_API_URL_BUTTON_SIZE_PX = 36;
export const PATROL_API_URL_BUTTON_GAP_PX = 5;
export const PATROL_API_URL_MARKER_HEIGHT_PX = 40;
export const PATROL_HOTSPOT_PRIMARY_BLUE = "#2563EB";

/**
 * @param {HTMLElement} el
 * @param {{ size?: number, zIndex?: string, selected?: boolean }} [opts]
 */
export function applyPatrolHotspotCircleMarkerStyle(
  el,
  {
    size = PATROL_HOTSPOT_MARKER_SIZE_PX,
    zIndex = "10",
    selected = false,
  } = {},
) {
  Object.assign(el.style, {
    position: "absolute",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: "0",
    boxShadow: "none",
    filter: selected ? "drop-shadow(0 0 6px rgba(34,197,94,0.9))" : "none",
    pointerEvents: "auto",
    cursor: "pointer",
    zIndex,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "translate(-50%, -50%)",
    width: `${size}px`,
    height: `${size}px`,
  });
}

/**
 * @param {string} iconUrl
 * @param {number} [iconSize]
 * @returns {HTMLImageElement}
 */
export function createPatrolHotspotIconImg(
  iconUrl,
  iconSize = PATROL_HOTSPOT_ICON_SIZE_PX,
) {
  const img = document.createElement("img");
  img.src = iconUrl;
  img.alt = "";
  img.setAttribute("aria-hidden", "true");
  Object.assign(img.style, {
    width: `${iconSize}px`,
    height: `${iconSize}px`,
    objectFit: "contain",
    display: "block",
    pointerEvents: "none",
  });
  return img;
}
